module.exports = __webpack_public_path__ + "static/scrape-zoom-f8c1678e60820548c306c6e78afeaa8e.jpg";